import { ComponentProps } from "react";

import { ContentCard } from "./ContentCard";
import { HorizontalCard } from "./HorizontalCard";
import { VerticalHalfCard } from "./VerticalHalfCard";

export const CurationContentCard = ({
    device,
    priority = false,
    ...props
}: Omit<ComponentProps<typeof ContentCard>, "type"> & {
    priority?: boolean;
}) => {
    const map = {
        "web+tablet": <VerticalHalfCard priority={priority} {...props} />,
        app: <HorizontalCard {...props} />
    };

    return device ? (
        map[device]
    ) : (
        <>
            <VerticalHalfCard
                className="hidden md:flex"
                priority={priority}
                {...props}
            />
            <HorizontalCard className="flex md:hidden" {...props} />
        </>
    );
};
